import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import data from '../../data/db.json';

import styles from './FinishStrong.module.scss'

const IndividualBlogPost = () => {

    const { id } = useParams();
    const postId = parseInt(id, 10);
    const postCount = data.length;
    const currentIndex = data.findIndex(post => post.id === postId);
    const previousPostId = currentIndex > 0 ? data[currentIndex - 1].id : data[postCount - 1].id;
    const nextPostId = currentIndex < postCount - 1 ? data[currentIndex + 1].id : data[0].id;
    const post = data.find(post => post.id === postId);



    if (!post) {
        return <div>Blog post not found.</div>;
    };

    return (
        <div className={styles.blogPosts}>
            <div className={styles.blogBar}>
                <Link to={`/post/${previousPostId}`}>Previous</Link>
                <Link to={`/post/${nextPostId}`}>Next</Link>
            </div>
            <h2>{post.title}</h2>
            <p>{post.date}</p>
            {post.content.map((section, index) => (
                <div key={index}>
                    <h3>{section.heading}</h3>
                    {section.text.map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                    ))}
                </div>
            ))}
            <div className={styles.blogBar}>
                <Link to={`/post/${previousPostId}`}>Previous</Link>
                <Link to={`/post/${nextPostId}`}>Next</Link>
            </div>
        </div>
    );
};

export default IndividualBlogPost;
